import React from 'react';
import PropTypes from 'prop-types';
import { PERIODS_TITLE } from '../../shared/FeatureReportConstants';
import { generateReactKey } from '../../../../utils/shared/commonUtils';

const PeriodCell = ({ period }) => (
    <div className="period-cell-express">
        <div className="period-cell-text">
            <span className="period-text">{period}</span>
            of Year
        </div>
        <div className={`${period !== PERIODS_TITLE.EOY && 'line'}`} />
    </div>
);

const PeriodsColumn = () => (
    <div className="periods-column">
        {Object.keys(PERIODS_TITLE).map(period => (
            <PeriodCell
                key={generateReactKey(PERIODS_TITLE[period])}
                period={PERIODS_TITLE[period]}
            />
        ))}
    </div>
);

PeriodCell.propTypes = {
    period: PropTypes.string,
};

PeriodCell.defaultProps = {
    period: '',
};

export default PeriodsColumn;
